module.exports = __webpack_public_path__ + "assets/images/age_g.9188d4df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/age_g.png
// module id = 672
// module chunks = 1